module.exports = __webpack_public_path__ + "static/media/values2016_enweb_0-min.98f2fd89.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/values2016_enweb_0-min.png
// module id = 173
// module chunks = 0